import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.submitting = false
  }

  submit() {
    if (this.submitting || !this.hasSelectTarget) return

    window.setTimeout(() => {
      if (this.submitting) return
      if (this.selectTarget.value.toString().trim() === "") return

      this.submitting = true
      this.element.requestSubmit()
    }, 0)
  }
}
